import React from "react";

export const plumaContent = (
  <div>
    <p className="content justified">
      El 19 de septiembre de 1910, nació en Gachetá (Cundinamarca) Oswaldo Díaz Díaz en el seno de una familia
      conservadora y católica. Sus padres fueron Juan de Dios Díaz y Celia Díaz Camacho. Don Os se dedicó a la docencia,
      igual que su padre y su hermano Sixto Antonio. Andrés María, su otro hermano, marcó su gusto por la aviación.
    </p>
    <p className="content justified">
      Se mudó a temprana edad a Bogotá y estudió primaria en el colegio de La Presentación. Allí conoció a uno de sus
      mejores amigos: el poeta Arturo Camacho Ramírez. El 15 de diciembre de 1927 obtuvo el título de bachiller en el
      Instituto de La Salle.
    </p>
    <p className="content justified">
      El 7 de septiembre de 1934 se graduó como Doctor en Derecho y Ciencias Políticas de la Universidad Nacional de
      Colombia. Sin embargo, nunca se dedicó a la jurisprudencia, sino a la educación y la escritura de cuentos, teatro
      y radioteatro.
    </p>
    <p className="content justified">
      El 28 de mayo de 1938 se casó con Josefina Piedrahíta con quien tuvo tres hijos: Andrés María (arquitecto), Juan
      Arturo (agrónomo) y Santiago (botánico).
    </p>
  </div>
);
